<template>
    <button
        :data-cy="dataCy"
        class="mr:px-8 mr:py-2 mr:leading-6 mr:rounded-full"
        :class="buttonClass"
        :disabled="props.disabled"
        v-bind="$attrs"
        @click="handleClick"
    >
        {{ text }}
    </button>
</template>

<script setup lang="ts">
import { computed, defineProps } from 'vue'

const emits = defineEmits(['click'])

const props = withDefaults(defineProps<{
    text: string
    variant?: 'primary' | 'secondary' | 'alert'
    dataCy?: string
    disabled?: boolean
}>(), {
    variant: 'primary',
    dataCy: undefined,
    disabled: false
})

const buttonClass = computed(() => {
    let baseClass, enabledClass

    switch (props.variant) {
        case 'primary':
            baseClass = 'mr:text-white mr:bg-brand-a'
            enabledClass = 'mr:hover:bg-brand-a-light mr:active:bg-brand-b'
            break
        case 'secondary':
            baseClass = 'mr:text-brand-a mr:border-2 mr:border-brand-a'
            enabledClass = 'mr:hover:text-white mr:hover:border-transparent mr:hover:bg-brand-a-light mr:active:bg-brand-b'
            break
        case 'alert':
            baseClass = 'mr:text-white mr:bg-red'
            enabledClass = 'mr:hover:bg-red-mid mr:active:bg-red-dark'
            break
    }


    return props.disabled ? `${baseClass} mr:opacity-50 mr:cursor-default` : `${baseClass} ${enabledClass}`
})

const handleClick = (event: Event) => {
    if (!props.disabled) {
        emits('click', event)
    }
}
</script>
